<app-header></app-header>
<section class="layout feature-module-overflow">
  <app-sidebar class="feature-module-overflow"></app-sidebar>

  <main #featuremodule class="feature-module-overflow main-height" *ngIf="attributeDetailsLoad">
    <router-outlet>
      <div class="header-management">
        <div class="headerTitle" *ngIf="!deviceId && !addTemplate && !isEdit && !isClone && !addBatch && !batchEdit">{{
          headerTitle|titlecase }}
        </div>
        <div class="headerTitle" *ngIf="deviceId || addTemplate || isEdit || isClone || addBatch || batchEdit">
          <span class="back-arrow-devicepayload" (click)="backToList(headerTitle)"></span>
          <span>{{ getHeaderTitle() }}</span>
        </div>
        <div class="d-flex gap10 place-self-end">
          <!-- <div class="link-direction-btn cursor" *ngIf="addDeviceEnable && sharedService.getTenantAvailability()"
            (click)="goToLink()">
            <div class="grafana-logo"><img src="../../../../assets/images/grafana.svg" alt="Logo"
                class="logo-class mr-2 ">
            </div>
            <div class="grafana-text">Grafana</div>
            <div class="grafana-arrow"><img src="../../../../assets/images/CaretRight-r.svg" alt="Logo"
                class="logo-class">
            </div>
          </div> -->
          <button *ngIf="addDeviceEnable && sharedService?.rbacManagement('EchoDeviceManagement_AddDevice')" class="echo-btn-common" (click)="addDevices()"
            [matTooltip]="allTenants ? 'Please select Tenant to add device' : ''"
            [disabled]="allTenants || addDeviceDisable"><img src="../../assets/images/add_device_circle.svg">Add
            Device</button>
        </div>

        <button *ngIf="addTemplateEnable && sharedService?.rbacManagement('EchoTemplateManagement_AddTemplate')" class="echo-btn-common" (click)="addTemplates()"><img
            src="../../assets/images/add_device_circle.svg">Add Template</button>
        <button *ngIf="addBatchEnable && sharedService?.rbacManagement('EchoBatchManagement_AddBatch')" class="echo-btn-common" (click)="addBatches()"
          [matTooltip]="allTenants ? 'Please select Tenant to add batch' : ''"
          [disabled]="allTenants || addBatchDisable"><img src="../../assets/images/add_device_circle.svg">Add
          Batch</button>
      </div>
    </router-outlet>
  </main>
</section>